import { factory, Factory } from 'almanac-ui/factory'
import { Heading as BlazeHeading, HeadingProps as BlazeHeadingProps } from 'blaze-ui/Heading/Heading'

export type HeadingLevel = 1 | 2 | 3 | 4

// TODO: Remove color prop when all heading variants are defined
interface HeadingProps {
  level: HeadingLevel
  color?: string
  children: React.ReactNode
}

export type HeadingFactory = Factory<{
  props: HeadingProps
  ref: HTMLHeadingElement
}>

const levelMap: Record<HeadingProps['level'], BlazeHeadingProps['level']> = {
  1: 1,
  2: 3,
  3: 4,
  4: 5,
}

export const Heading = factory<HeadingFactory>(({ level, children, ...otherProps }, ref) => {
  return (
    <BlazeHeading level={levelMap[level]} {...otherProps} ref={ref}>
      {children}
    </BlazeHeading>
  )
})
